export default __webpack_public_path__ + "fonts/Avenir-Heavy.svg";